import {
  convertToISOString,
  getFormattedDate,
  getFormattedTime,
} from 'components/Rewards/utils'
import API from '../../../lib/api'

export const formatPromotionalPrice = (promotionalPrice) => {
  if (promotionalPrice?.length > 0 && promotionalPrice[0].price) {
    return promotionalPrice.map((item) => {
      const startAt = convertToISOString(item.startDate, item.startTime)
      const endAt = convertToISOString(item.endDate, item.endTime)
      return { price: item.price, startAt, endAt }
    })
  }
  return null
}

export const getFormattedPromotionalPrice = (promotionalPrice) => {
  if (promotionalPrice?.length > 0 && promotionalPrice[0].price) {
    return promotionalPrice.map((item) => ({
      price: item.price,
      startDate: getFormattedDate(item.startAt),
      startTime: getFormattedTime(item.startAt),
      endDate: getFormattedDate(item.endAt),
      endTime: getFormattedTime(item.endAt),
    }))
  }
  return []
}

export const formatUsuageValidityData = (mapData, stateValues) => {
  const { usageType, usedByDate, usedByTime, useWithinDays } = stateValues
  if (usageType === 'Fixed') {
    const useByDate = convertToISOString(usedByDate, usedByTime)
    mapData.useByDate = useByDate
    mapData.useWithinDays = null
  }

  if (usageType === 'Relative') {
    mapData.useWithinDays = useWithinDays
    mapData.useByDate = null
  }
  return mapData
}

export const formatMetaData = (mapData, metadata, type) => {
  mapData.metadata = {
    cost: Number(metadata.cost),
    costCenter: metadata.costCenter,
    faceValue: Number(metadata.faceValue),
    segmentIds: formatSegments(metadata.segmentIds),
    ...(type === 'FP_EVOUCHER' && {
      voucher: { denomination: Number(metadata.voucher.denomination) },
    }),
    ...(type === 'FPG_PRODUCT_VOUCHER' && {
      product: {
        ...(metadata.product?.offerId && {
          offerId: Number(metadata.product.offerId),
        }),
        ...(metadata.product?.dspTemplateCode?.trim() && {
          dspTemplateCode: metadata.product.dspTemplateCode.trim(),
        }),
      },
    }),
    mechanics: metadata.mechanics,
  }
  return mapData
}

export const formatSegments = (data = []) => {
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((item) => item.id)
}

export const fetchSegments = async (segmentIds = []) => {
  if (!Array.isArray(segmentIds) || !segmentIds.length) {
    return []
  }

  const api = new API({ url: '/segments' })
  const { data = [] } = await api.get({ limit: 10000 })
  const segmentMap = new Map(data.map((item) => [item.id, item]))

  return segmentIds.map((id) => segmentMap.get(Number(id))).filter(Boolean)
}
